"use strict";
var Observable_1 = require('../../Observable');
var bufferCount_1 = require('../../operator/bufferCount');
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/~/rxjs/add/operator/bufferCount.js
// module id = ../../../../rxjs/add/operator/bufferCount.js
// module chunks = 3